import MainWrapper from "../../components/MainWrapper";
import MyProjects from "./MyProjects";
import UXAnalysis from "./UXAnalysis";

const DashboadPage = () => {
    return (
        <MainWrapper className="bg-2">
            <div className="container-lg container-fluid">
                <div className="row">
                    <div className="col-md-9 mx-auto">
                        <MyProjects />
                        <UXAnalysis />
                    </div>
                </div>
            </div>
        </MainWrapper>
    );
};

export default DashboadPage;
